// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CJtiC","paragraph":"styles_paragraph__FBd7u"};